import React, { useRef, useState, useEffect } from "react";
import { data, useParams } from "react-router-dom";
import axios from "../api/axiosInstance";

// Images
import guitar from '../assets/images/hobbies/guitar.png';
import worldBookDay from '../assets/images/hobbies/world-book-day.png';
import pressConference from '../assets/images/hobbies/press-conference.png';
import aiAssistant from '../assets/images/hobbies/ai-assistant.png';
import programming from '../assets/images/hobbies/programming.png';
import science from '../assets/images/hobbies/science.png';
import gameConsole from '../assets/images/hobbies/game-console.png';
import artsAndCrafts from '../assets/images/hobbies/arts-and-crafts.png';
import strategy from '../assets/images/hobbies/strategy.png';
import americanFootball from '../assets/images/hobbies/american-football.png';
import Navbar from "../components/Navbar/Navbar";
import { toast } from "react-toastify";

const hobbiesIcons = [
  { name: 'Music', src: guitar },
  { name: 'Reading', src: worldBookDay },
  { name: 'Speech', src: pressConference },
  { name: 'AI', src: aiAssistant },
  { name: 'Programming', src: programming },
  { name: 'Science', src: science },
  { name: 'Games', src: gameConsole },
  { name: 'Arts & Crafts', src: artsAndCrafts },
  { name: 'Strategy', src: strategy },
  { name: 'Football', src: americanFootball }
];

const ChildProfilePage = () => {
  const { id: encodedId } = useParams();
  const [realId, setRealId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [canEdit, setCanEdit] = useState(false);
  const [notAllowed, setNotAllowed] = useState(false);

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    childBirthdate: "",
    age: "",
    aboutMe: "",
    achievement: "",
    future: "",
    hobbies: [],
    profile_picture: null,
      isPublic: false  // <--- Add this line
  });
  const fileInputRef = useRef();
  const [profilePic, setProfilePic] = useState(null);

  // Decode Base64 on mount
  useEffect(() => {
    try {
      const decoded = atob(encodedId); // Decode base64
      setRealId(decoded);
    } catch (e) {
      console.error("Invalid base64 ID in URL");
      setNotAllowed(true);
      setLoading(false);
    }
  }, [encodedId]);



  useEffect(() => {
  // Only fetch if you actually have a key
  const fetchProfilePicture = async () => {
    if (!form.profile_picture) return;
    try {
      const res = await axios.post(`/v1/image/getSignedProfilePicture/`, {
        key: form.profile_picture
      });
      console.log(res.data)
      if (res.data.status === "success") {

        setProfilePic(res.data.signedUrl);
      } else {
        setProfilePic(null);
        console.error("Failed to fetch profile picture:", res.data.message);
      }
    } catch (err) {
      setProfilePic(null);
      console.error("Error fetching profile picture:", err);
    }
  };

  fetchProfilePicture();
}, [form.profile_picture, axios]);




  // Fetch the child's actual profile data
  useEffect(() => {


  



    if (!realId) return;

    const fetchData = async () => {
      try {
        const res = await axios.get(`/v1/profile/kid/${realId}`);
        const data = res.data.data;

        if (!data) {
          setNotAllowed(true);
          return;
        }

        const isAllowed =
          data.isPublic === 1 || data.canEdit === true;

        if (!isAllowed) {
          setNotAllowed(true);
          return;
        }

        // Populate form with fetched data
        setForm({
          firstName: data.first_name || "",
          lastName: data.last_name || "",
          childBirthdate: data.child_birthdate ? data.child_birthdate.split("T")[0] : "",
          age: data.age || "",
          aboutMe: data.about_me || "",
          achievement: data.achievement || "",
          future: data.future || "",
          hobbies: data.hobbies ? data.hobbies.split(",").map(h => h.trim()) : [],
          profile_picture: data.profile_picture,
            isPublic: data.isPublic === 1 
        });

       

        setCanEdit(data.canEdit === true);
      } catch (err) {
        console.error("Error loading profile", err.message);
        setNotAllowed(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [realId]);


 
  // ========== Handlers ==========

 const handlePicChange = async (e) => {
  const file = e.target.files[0];

  if (!file) return;

  try {
    // Create FormData and append the image
    const formData = new FormData();
    formData.append("image", file);

    // Make authenticated request
    const res = await axios.post("/v1/image/uploadProfilePicture", formData);

   
    if (res.data && res.data.data && res.data.data.key) {
      setProfilePic(res.data.data.signedUrl); // set URL from server
      setForm(prev => ({ ...prev, profile_picture: res.data.data.key }));
      toast.success("Profile picture updated!");
    } else {
      toast.error("Upload failed. Try again!");
    }
  } catch (error) {
    console.error("Profile picture upload error:", error);
    toast.error("Profile picture upload failed!");
  }
};


const handleChange = (e) => {
  const { name, value } = e.target;

  // If user changes birthdate, also recalculate age
  if (name === "childBirthdate") {
    const age = calculateAge(value);

    setForm((prev) => ({
      ...prev,
      childBirthdate: value,
      age: age.toString()
    }));
  } else {
    setForm((prev) => ({ ...prev, [name]: value }));
  }
};

// Utility to calculate age from birthdate
const calculateAge = (birthdateStr) => {
  const today = new Date();
  const birthDate = new Date(birthdateStr);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return Math.max(0, age);
};


  const toggleHobby = (name) => {
    setForm((prev) => {
      const exists = prev.hobbies.includes(name);
      const hobbies = exists
        ? prev.hobbies.filter((h) => h !== name)
        : [...prev.hobbies, name];

      return { ...prev, hobbies };
    });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    if (!form.firstName || !form.childBirthdate) {
      toast.warning("First name and birthdate are required");
      return;
    }

const payload = {
  first_name: form.firstName,
  last_name: form.lastName,
  age: form.age || null,
  child_birthdate: form.childBirthdate,
  about_me: form.aboutMe,
  hobbies: form.hobbies.join(','),
  achievement: form.achievement,
  future: form.future,
  profile_picture: form.profile_picture || null,
  isPublic: form.isPublic
};


    const res = await axios.put(`/v1/profile/kid/${realId}`, payload);

    if (res.data.status === "success") {
      toast.success("Profile updated successfully 🎉");
    } else {
      toast.error("Update failed! Please try again.");
    }
  } catch (err) {
    console.error("Profile update failed:", err);
    toast.error("Something went wrong!");
  }
};



  // ========== Conditional Rendering ==========
  if (loading) return <div style={{ padding: 40 }}>Loading profile...</div>;
  if (notAllowed) return <h3 style={{ padding: 40, color: "red" }}>Access Denied: You are not authorized to view this profile.</h3>;

  // ========== Main JSX ==========
  return (
    <div
      style={{
        fontFamily: "'Nunito', sans-serif",
        minHeight: "100vh",
        background: "#fff",

      }}
    >
            <Navbar />

      <link
        href="https://fonts.googleapis.com/css?family=Nunito:400,700&display=swap"
        rel="stylesheet"
      />
      <div style={{ maxWidth: 540, margin: "0 auto" }}>
    
        <div
          style={{
            fontWeight: 700,
            letterSpacing: 4,
            fontSize: 20,
            marginBottom: 32
          }}
        >
          CHILD'S PROFILE
        </div>

        {/* Profile Upload */}
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 32 }}>
          <div
            onClick={() => fileInputRef.current.click()}
            style={{
              border: "2px solid #FA7A2F",
              borderRadius: "50%",
              width: 180,
              height: 180,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              cursor: canEdit ? "pointer" : "default",
              position: "relative"
            }}
          >
            {profilePic ? (
              <img
                src={profilePic}
                alt="Profile"
                style={{
                  width: 180,
                  height: 180,
                  borderRadius: "50%",
                  objectFit: "cover"
                }}
              />
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center"
                  }}
                >
                  <span style={{ color: "#FA7A2F", fontSize: 38, marginBottom: 6 }}>
                    ⬆️
                  </span>
                  <div
                    style={{
                      fontSize: 13,
                      color: "#fa7a2f",
                      fontWeight: 700,
                      marginBottom: 6
                    }}
                  >
                    OR DROP FILE TO UPLOAD
                  </div>
                </div>
              </>
            )}
            {canEdit && (
              <input
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                ref={fileInputRef}
                onChange={handlePicChange}
              />
            )}
          </div>
        </div>

        {/* Edit Form */}
        <form onSubmit={handleSubmit}>
          <div style={{ display: "flex", gap: 12, marginBottom: 18 }}>
            <FormInput
              label="FIRST NAME"
              name="firstName"
              value={form.firstName}
              onChange={handleChange}
              canEdit={canEdit}
            />
            <FormInput
              label="LAST NAME"
              name="lastName"
              value={form.lastName}
              onChange={handleChange}
              canEdit={canEdit}
            />
          </div>

          <FormInput
            label="AGE"
            name="age"
            type="number"
            value={form.age}
            onChange={handleChange}
            canEdit={canEdit}
            width="180px"
          />

          <FormInput
  label="DATE OF BIRTH"
  name="childBirthdate"
  type="date"
  value={form.childBirthdate}
  onChange={handleChange}
  canEdit={canEdit}
/>



          <FormTextarea
            label="ABOUT ME"
            name="aboutMe"
            value={form.aboutMe}
            onChange={handleChange}
            canEdit={canEdit}
          />

          {/* --- HOBBIES --- */}
          <div style={{ marginBottom: 18 }}>
            <div style={{ fontSize: 12, letterSpacing: 2, fontWeight: 600, marginBottom: 10 }}>
              HOBBIES
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 16 }}>
              {hobbiesIcons.map((hobby) => (
                <label key={hobby.name} style={{ cursor: canEdit ? "pointer" : "default" }}>
                  <input
                    type="checkbox"
                    disabled={!canEdit}
                    checked={form.hobbies.includes(hobby.name)}
                    onChange={() => toggleHobby(hobby.name)}
                    style={{ display: "none" }}
                  />
                  <img
                    src={hobby.src}
                    alt={hobby.name}
                    title={hobby.name}
                    style={{
                      width: 52,
                      height: 52,
                      borderRadius: 10,
                      outline: form.hobbies.includes(hobby.name)
                        ? "2.5px solid #FA7A2F"
                        : "2.5px solid transparent",
                      transition: "outline 0.15s"
                    }}
                  />
                </label>
              ))}
            </div>
          </div>


          {canEdit && (
  <div style={{ marginBottom: 24 }}>
    <label style={{ fontSize: 14, fontWeight: 600 }}>
      <input
        type="checkbox"
        checked={form.isPublic}
        onChange={(e) => setForm((prev) => ({ ...prev, isPublic: e.target.checked }))}
        style={{ marginRight: 8 }}
      />
      Make this childs profile public
    </label>
  </div>
)}


          <FormInput
            label="ACHIEVEMENT"
            name="achievement"
            value={form.achievement}
            onChange={handleChange}
            canEdit={canEdit}
          />
          <FormInput
            label="FUTURE"
            name="future"
            value={form.future}
            onChange={handleChange}
            canEdit={canEdit}
          />

          {canEdit && (
            <button
              type="submit"
              style={{
                fontFamily: "inherit",
                fontWeight: 700,
                fontSize: 16,
                letterSpacing: 9,
                color: "#111",
                background: "none",
                border: "none",
                cursor: "pointer",
                float: "right"
              }}
            >
              SAVE
            </button>
          )}
        </form>
      </div>
    </div>
  );
};

export default ChildProfilePage;

const FormInput = ({ label, ...props }) => (
  <div
    style={{
      flex: props.width ? "initial" : 1,
      marginBottom: 18,
      width: props.width || "100%"
    }}
  >
    <div style={{ fontSize: 12, letterSpacing: 2, fontWeight: 600, marginBottom: 3 }}>{label}</div>
    <input
      {...props}
      disabled={!props.canEdit}
      style={{
        width: "100%",
        border: "1.3px solid #fa7a2f40",
        borderRadius: 20,
        padding: "8px 14px",
        fontFamily: "inherit",
        backgroundColor: props.canEdit ? "white" : "#f6f6f6"
      }}
    />
  </div>
);

const FormTextarea = ({ label, ...props }) => (
  <div style={{ marginBottom: 18 }}>
    <div style={{ fontSize: 12, letterSpacing: 2, fontWeight: 600, marginBottom: 3 }}>{label}</div>
    <textarea
      {...props}
      disabled={!props.canEdit}
      rows={3}
      style={{
        width: "100%",
        border: "1.3px solid #fa7a2f40",
        borderRadius: 20,
        padding: "12px 14px",
        fontFamily: "inherit",
        resize: "none",
        backgroundColor: props.canEdit ? "white" : "#f6f6f6"
      }}
    />
  </div>
);
